import Vue from 'vue';
import App from './App.vue';
import router from './router';  // 引入路由
import store from './store';    // 引入 Vuex
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.prototype.$axios = axios;

new Vue({
    router,  // 注册路由
    store,   // 注册 Vuex
    render: h => h(App)
}).$mount('#app');